/**
 * @readonly
 * @enum {string}
 */
export const ObjectFuelUsages = {
    AVERAGE_VEHICLE_FUEL_CONSUMPTION: 'AVERAGE_VEHICLE_FUEL_CONSUMPTION',
    CUSTOM_FLEET_FUEL_CONSUMPTION: 'CUSTOM_FLEET_FUEL_CONSUMPTION',
    CUSTOM_VEHICLE_FUEL_CONSUMPTION: 'CUSTOM_VEHICLE_FUEL_CONSUMPTION'
}
